import Vue from 'vue'
import App from './App.vue'
import RestClient from './libs/RestClient'
import VueCookies from 'vue-cookies'
import VueSwal from 'vue-swal'

Vue.use(VueSwal)

Vue.use(VueCookies)

Vue.use(RestClient)

Vue.use(VueSwal)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
